<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" width="900px" top="1vh" @close="close">
    <!-- 所属用户 -->
    <el-form v-if="dialogFormVisible" ref="form" :model="form" :rules="rules" label-width="95px">
      <el-form-item label="所属用户">
        <div style="display: flex; align-items: cetner">
          <el-select ref="select" style="width: 370px;" v-model="form.uid" filterable remote reserve-keyword
            placeholder="请输入关键词" :remote-method="remoteMethod" @focus="clear" @hook:mounted="clear"
            @visible-change="clear" @change="getInfo">
            <!-- item.code ?  -->
            <!-- <el-option v-for="item in options" :key="item.id" :label="`${item.nickname}
            （${`${item.code}/${item.ydm_code}/${item.ydr_code}/${item.cm_code}`}）`"
            :value="item.id"></el-option> -->
            <el-option v-for="item in options" :key="item.id"
              :label="`${item.nickname}（${item.code ? item.code : ''}${item.ydm_code ? '/' + item.ydm_code : ''}${item.ydr_code ? '/' + item.ydr_code : ''}${item.cm_code ? '/' + item.cm_code : ''}）`"
              :value="item.id">
            </el-option>
          </el-select>
          <el-button type="primary" size="mini" style="margin-left: 15px" @click="clearUserInfo">
            清除历史记录
          </el-button>
        </div>
      </el-form-item>
      <!-- 所属状态 -->
      <el-form-item label="所属状态" prop="status">
        <el-select v-model="form.status" placeholder="请选择">
          <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="线路" prop="status">
        <el-select @change="line_change" v-model="form.kor_type" placeholder="请选择">
          <el-option v-for="item in countryList" :key="item.type" :label="item.name" :value="item.type"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属库位" prop="storage_location">
        <el-select filterable v-model="form.storage_location" placeholder="请选择">
          <el-option v-for="item in kuweiList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-button type="primary" style="margin-left: 15px;" @click="copy(form.storage_location)">
          复制库位号
        </el-button>
      </el-form-item>
      <!-- 仓库所在区 -->
      <el-form-item v-if="showCangku" label="仓库所在区" prop="type">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <!-- 超时的仓储费 -->
      <el-form-item label="仓储费用">
        <el-input v-model="form.storage_price" @input="form.storage_price = $geShi(form.storage_price)" maxlength="6"
          show-word-limit autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item v-if="korShow" label="原包裹单号" prop="old_kr_code">
        <el-input v-model.trim="form.old_kr_code" autocomplete="off"></el-input>
      </el-form-item>
      <!-- 包裹单号 -->
      <el-form-item label="包裹单号" prop="code">
        <el-input v-if="title == '添加'" v-model.trim="form.code" autocomplete="off" show-word-limit maxlength="60"></el-input>
        <el-input v-else v-model.trim="form.code" :disabled="isShowCode" autocomplete="off" show-word-limit maxlength="60"></el-input>
      </el-form-item>
      <!-- 运单号 -->
      <el-form-item label="运单编号" prop="express_code">
        <el-input v-model.trim="form.express_code" autocomplete="off" show-word-limit maxlength="25"></el-input>
      </el-form-item>
      <!-- 重量 -->
      <el-form-item label="订单重量" prop="weight">
        <el-input v-model.trim="form.weight" autocomplete="off" maxlength="8" show-word-limit
          @input="handleInputWeight"></el-input>
      </el-form-item>
      <!-- 价格 -->
      <el-form-item label="订单价格" prop="price">
        <el-input v-model.trim="form.price" autocomplete="off" maxlength="8" show-word-limit
          @input="handleInputPrice"></el-input>
      </el-form-item>
      <el-form-item label="收货人" prop="name">
        <el-input v-model.trim="form.name" autocomplete="off" maxlength="15" show-word-limit
          @input="handleInputPrice"></el-input>
      </el-form-item>
      <el-form-item label="收货人电话" prop="phone">
        <el-input v-model.trim="form.phone" autocomplete="off" maxlength="15" show-word-limit
          @input="handleInputPrice"></el-input>
      </el-form-item>
      <el-form-item label="邮编" prop="phone">
        <el-input v-model.trim="form.zipcode" autocomplete="off" maxlength="15" show-word-limit></el-input>
      </el-form-item>
      <!-- 收货地址 -->
      <el-form-item label="收货地址" prop="price">
        <!-- <el-input disabled v-model="city_text"></el-input> -->
        <!-- <el-cascader :placeholder="city_text" :props="props" @change="choosecity"></el-cascader> -->
        <el-cascader style="width: 500px;" v-model="address" :props="props" :options="options2"
          @change="choosecity"></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址" prop="address">
        <el-input type="textarea" v-model.trim="form.address" autocomplete="off" maxlength="500"
          show-word-limit></el-input>
      </el-form-item>
      <!-- 备注 -->
      <el-form-item label="备注" prop="remark2">
        <!-- <City-selection :info="form"></City-selection> -->
        <el-input v-model.trim="form.remark2" autocomplete="off" maxlength="80" show-word-limit></el-input>
      </el-form-item>

      <!-- 产品图片 -->
      <el-form-item label="包裹图片" prop="pic">
        <uploadFile :limit="1" :img-list-string="form.pic" @fileChange="uploadChange($event, 'pic')" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" :loading="save_loading" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  orderDetail,
  memberListAll,
  orderUpdate,
  ordergetEnableLocation,
  orderGetAllStorageLocation,
  YdrApi_efs_notice,
  Index_country_list
} from '@/api/xgcApi'
import {
  getUploadUrl
} from '@/config'
import uploadFile from '@/components/uploadFile'
import CitySelection from '@/components/CitySelection'
import {
  goodsAdd,
  index_city,
  Index_city_tree
} from '../../../api/xgcApi'
import {
  number
} from 'echarts'

export default {
  name: 'UserManagementEdit',
  components: {
    uploadFile,
    CitySelection,
  },
  data() {
    return {
      order_row: {},//订单信息
      save_loading: false,
      options2: [], //马来地址树
      address: [],
      props: {
        value: 'name',
        label: 'name',
        children: 'sub',
      },
      visible: false,
      city_text: '-',
      loading: false,
      options: [],
      typeList: [{
        label: '韩区包裹',
        value: 1,
      },
      {
        label: '日区包裹',
        value: 2,
      },
      ],
      statusList: [{
        value: 0,
        label: '未入库',
      },
      {
        value: 1,
        label: '已入库',
      },
      {
        value: 2,
        label: '待审核',
      },
      {
        value: 3,
        label: '待打包',
      },
      {
        value: 4,
        label: '待发货',
      },
      {
        value: 5,
        label: '待支付',
      },
      {
        value: 6,
        label: '转运中',
      },
      {
        value: 7,
        label: '已签收',
      },
      {
        value: 8,
        label: '已拒绝',
      },
      {
        value: 10,
        label: '暂存',
      },
      {
        value: 11,
        label: '退款中',
      },
      {
        value: 12,
        label: '已退款',
      },
      ],
      kuweiList: [],
      showCangku: false,
      form: {
        uid: '',
        status: '',
      },
      clear_storage_location: '1',
      dialogFormVisible: false,
      rules: {
        type: [{
          required: true,
          trigger: 'blur',
          message: '请选择仓库所在区',
        },],
        code: [{
          required: true,
          trigger: 'blur',
          message: '请输入包裹单号',
        },],
        uid: [{
          required: true,
          trigger: 'change',
          message: '请选择所属用户',
        },],
      },
      title: '',
      isShowCode: false,
      korShow: false,
      countryList: []
    }
  },

  created() {
    this.getType_list()
  },
  methods: {
    line_change(index) {
      // 线路切换
      console.log(this.countryList[index], '当前线路')

      this.getAllkuweiList()
    },
    getType_list() {
      // 获取线路
      // Index_country_list
      var data = {}
      Index_country_list(data).then(res => {
        this.countryList = res.data
      })
    },
    copy(text) {
      if (text) {
        var textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.$message({
          type: 'success',
          message: '复制成功!'
        })
      } else {
        this.$message({
          type: 'info',
          message: '暂无可复制内容!'
        })
      }

    },
    // 获取库位列表
    getkuweiList(data = {}) {
      ordergetEnableLocation(data).then((res) => {
        this.kuweiList = res.data
      })
    },
    // 获取全部库位
    getAllkuweiList(data = {}) {
      var arr = []
      data.kor_type = this.form.kor_type
      orderGetAllStorageLocation(data).then((res) => {
        res.data.forEach((item, index) => {
          arr.push(item.store_number)
        })
        arr.unshift("中到马订单虚拟库位");
        this.kuweiList = arr
      })
    },
    clearUserInfo() {
      localStorage.setItem('userUid', null)
      localStorage.setItem('userInfo', null)
      this.form.uid = null
    },
    // 点击清空库位
    clearKuwei() {
      this.visible = true
    },
    confirmClear() {
      this.clear_storage_location = '2'
      this.visible = false
    },
    choosecity(e) {

      if (e[0] == 'East Malaysia') {
        // 东马''
        this.form.province = 1
      } else {
        // 西马
        this.form.province = 2
      }
      this.form.zhou = e[1]
      this.form.city = e[2]
      this.address = e
      console.log(this.address, '-----')
    },
    // 获取省事区
    getcityList() {

      Index_city_tree({
        kor_type: 4
      }).then((res) => {
        this.options2 = res.data
      })
    },
    // 解决移动端，点击不显示键盘问题
    // 调起移动端键盘
    clear(async) {
      this.$nextTick(() => {
        if (!async) {
          // ios 手机有延迟问题
          setTimeout(() => {
            const {
              select
            } = this.$refs
            const input = select.$el.querySelector('.el-input__inner')
            input.removeAttribute('readonly')
          }, 200)
        }
      })
    },
    // // 解决ios移动端选择双击问题
    // recordTouchStart(event) {
    //   const u = navigator.userAgent
    //   const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    //   if (isiOS && this._isMobile()) {
    //     event.visible = true //only work in iOS
    //   }
    // },
    // _isMobile() {
    //   return navigator.userAgent.match(
    //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    //   )
    // },

    // 用户筛选
    remoteMethod(e) {
      this.page = 1
      this.limit = 20
      var data = {
        nickname: e,
        page: 1,
        limit: 100,
        kor_type: this.form.kor_type
      }
      memberListAll(data).then(({
        data
      }) => {
        this.options = data
      })
    },
    // 重量输入校验
    handleInputWeight() {
      // 移除非数字和非小数点字符，保留小数点
      this.form.weight = this.form.weight
        .replace(/[^\d.]/g, '')
        // 保留第一个小数点，移除其他小数点
        .replace(/^(\d*\.)(.*)\./g, '$1$2')
        // 移除前导零，但保留小数点前的单个零
        .replace(/^0+(\d+\.{0,1}\d*)/, '$1')
    },
    // 价格输入校验
    handleInputPrice() {
      // 移除非数字和非小数点字符，保留小数点
      this.form.weight = this.form.weight
      this.form.price = this.form.price
        .replace(/[^\d.]/g, '')
        // 保留第一个小数点，移除其他小数点
        .replace(/^(\d*\.)(.*)\./g, '$1$2')
        // 移除前导零，但保留小数点前的单个零
        .replace(/^0+(\d+\.{0,1}\d*)/, '$1')
    },
    // 上传图片
    uploadChange(e) {
      var strurl = e.join(',')
      strurl = strurl.replace('\\\\', '\/\/')
      strurl = strurl.replace('\\', '\/')
      strurl = strurl.replace('\\', '\/')
      this.form.pic = strurl
    },
    // 初始化请求数据
    // country，type  1=韩国，2=日本
    async showEdit(row) {
      this.order_row = row
      this.loading = true
      this.getcityList()
      if (row.country == 1) {
        this.title = '添加'
        this.form.type = '1'
        this.loadFromCache()
        this.getUserInfo()
        this.getAllkuweiList()
      } else if (row.country == 2) {
        this.title = '添加'
        this.form.type = '2'
        this.loadFromCache()
        this.getUserInfo()
      } else {
        this.title = '订单编辑'
        this.form.type = row.type
        this.form.kor_type = row.kor_type
        this.korShow = true
        // this.getkuweiList()
        this.getAllkuweiList()
        if (
          row.status == 4 ||
          row.status == 5 ||
          row.status == 6 ||
          row.status == 7 ||
          row.status == 10
        ) {
          this.isShowCode = true
        } else {
          this.isShowCode = false
        }
        orderDetail({
          id: row.id,
        }).then(({
          data
        }) => {

          this.form = data
          if (data.city) {
            if (data.kor_type == 4 || data.kor_type == 5) {
              // this.city_text = `${data.province==1?'东马':'西马'} / ${data.zhou} / ${data.city}`
              this.form.province == 1 ? this.form.province = 'East Malaysia' : this.form.province = 'West Malaysia'
              this.address = [this.form.province, this.form.zhou, this.form.city]

            } else {
              this.city_text = `${data.province}/${data.city}/${data.area}`
            }
          }
          if (data.userInfo) {
            this.form.uid = data.userInfo.id ? data.userInfo.id : ''
            this.getUserInfo({})
          } else {
            this.getUserInfo({})
          }
          if (this.form.type == 0) {
            this.form.type = null
          }

        })
      }
      this.dialogFormVisible = true
    },
    // 获取选中的所属用户信息
    getInfo(value) {
      // this.getkuweiList({uid:value})
      this.options.forEach((item, index) => {
        if (value == item.id) {
          localStorage.setItem('userUid', item.id)
          localStorage.setItem('userInfo', JSON.stringify(item))
        }
      })
    },
    async getUserInfo(e) {
      var data = {
        ...e,
        page: 1,
        limit: 100,
        kor_type: this.form.kor_type
      }
      try {
        const { data: userList } = await memberListAll(data)
        if (this.form.userInfo) {
          // 更精确的查找：直接比较 id 字段
          let found = userList.some((obj) => obj.id == this.form.userInfo.id)
          if (!found) {
            // 创建新数组而不是修改原数组
            this.options = [...userList, this.form.userInfo]
          } else {
            this.options = userList
          }
        } else {
          this.options = userList
        }
        this.loading = false
      } catch (error) {
        console.error('获取用户信息失败:', error)
        this.options = []
        this.loading = false
        // 可选：显示错误提示
        // this.$message.error('获取用户信息失败')
      }
    },
    // 本地缓存中取uid
    loadFromCache() {
      if (localStorage.getItem('userUid')) {
        let numObj = Number(localStorage.getItem('userUid'))
        this.form.uid = numObj
        this.form.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      } else {
        this.form.uid = ''
        this.form.userInfo = null
      }
    },
    // 关闭弹窗
    close() {

      this.form = this.$options.data().form
      this.clear_storage_location = '1'
      for (var key in this.form) {
        this.form[key] = null
      }
      this.korShow = false
      this.dialogFormVisible = false
      this.$refs['form'].resetFields()
    },

    // 提交修改//修改传ID  添加不传ID
   async save() {
  // 1. 先做表单校验，失败直接返回，不用进 loading
  const valid = await this.$refs['form'].validate().catch(() => false)
  if (!valid) return

  const setData = {
    id: this.form.id,
    uid: this.form.uid || null,
    type: this.form.type,
    status: this.form.status || '',
    pic: this.form.pic,
    code: this.form.code,
    express_code: this.form.express_code,
    weight: this.form.weight,
    price: Number(this.form.price),
    province: this.form.province,
    city: this.form.city,
    area: this.form.area,
    address: this.form.address,
    name: this.form.name,
    phone: this.form.phone,
    idcode: this.form.idcode,
    remark2: this.form.remark2,
    zhou: this.form.zhou,
    clear_storage_location: this.clear_storage_location,
    storage_location: this.form.storage_location,
    old_kr_code: this.form.old_kr_code,
    storage_price: this.form.storage_price,
    kor_type: this.form.kor_type,
    zipcode: this.form.zipcode,
  }

  this.save_loading = true
  try {
    const res = await orderUpdate(setData)
    // 2. 根据接口真实返回判断成功/失败（code 字段名按你后端实际来）
    const isSuccess = res.code === 200 || res.code === 0 || res.success === true
    if (isSuccess) {
      this.$baseMessage(res.msg || '操作成功', 'success')
      this.$emit('fetch-data')
      this.clear_storage_location = '1'
      this.close()
    } else {
      // this.$baseMessage(res.msg, 'error')
    }
  } catch (err) {
    // 3. 网络/服务异常兜底提示
    // this.$baseMessage(err?.message, 'error')
  } finally {
    // 4. 无论成功失败都恢复 loading
    this.save_loading = false
  }
}
  },
}
</script>
<style scoped lang="scss">
:deep .el-input--small .el-input__inner {}

// :deep .el-scrollbar .el-scrollbar__bar {
//   opacity: 1 !important;
// }
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
